const calendarDisplay = (state = {}, action) => {
  switch (action.type) {
    case 'FIREBASE_CALENDARS_UPDATE_VALUE': {
      // Updating something else inside Calendars
      if (action.label.indexOf('dispProps') === -1) {
        return state
      }
      const calendarId = action.id
      const dateStr = action.label.substring('dispProps/'.length)
      const calendarState = state[calendarId] || {}
      // Set the new value
      return Object.assign({}, state, {
        [calendarId]: Object.assign({}, calendarState, {
          [dateStr]: action.value
        })
      })
    }
    default:
      return state
  }
}

export default calendarDisplay



// WEBPACK FOOTER //
// ./src/infra/reducers/firebase/calendarDisplay.js